import { useEffect, useState } from 'react';
import { formatCurrency } from '@shared/formatCurrency';

interface AnimatedCostDisplayProps {
  value: number;
}

export function AnimatedCostDisplay({ value }: AnimatedCostDisplayProps) {
  const [displayValue, setDisplayValue] = useState(value);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (value === displayValue) return;

    setIsTransitioning(true);

    const fadeOutTimer = setTimeout(() => {
      setDisplayValue(value);
      setIsTransitioning(false);
    }, 400);

    return () => clearTimeout(fadeOutTimer);
  }, [value]);

  return (
    <span
      className="inline-block transition-all duration-400 ease-in-out"
      style={{
        opacity: isTransitioning ? 0 : 1,
        transform: isTransitioning ? 'translateY(4px)' : 'translateY(0)',
      }}
    >
      {formatCurrency(displayValue)}
    </span>
  );
}
